import { Ref, ComputedRef, computed } from '@vue/composition-api';

export default (...refs: Ref<boolean>[]): ComputedRef<boolean> => computed(() => refs.some((value) => value.value));
